import * as React from "react";
import { connect } from "react-redux";

import { Site, Nav, Dimmer } from "@/components/ui/shadcn-compat";

import withAuth from "../../utils/withAuth";

interface Props {
  auth: any;
  isLoading: any;
}

class NavigationItems extends React.Component<Props> {
  iterateNavItems(isAuthenticated) {
    let navArray;

    if (isAuthenticated) {
      navArray = [
        {
          name: "Home",
          action: "/"
        },
        {
          name: "Jobs",
          action: "/jobs"
        },
        {
          name: "Blog",
          action: "https://blog.hirexl.in/"
        },
        {
          name: "Applied Jobs",
          action: "/applied-jobs"
        }
      ];
    } else {
      navArray = [
        {
          name: "Home",
          action: "/"
        },
        {
          name: "Jobs",
          action: "/jobs"
        },
        {
          name: "Blog",
          action: "https://blog.hirexl.in/"
        }
      ];
    }
    let navItems = navArray.map((item, i) => {
      return <Nav.Item key={i} value={item.name} to={item.action} />;
    });
    return navItems;
  }

  render() {
    const { isLoading, auth } = this.props;

    const isAuthenticated = isLoading ? null : auth.loggedIn();
    return (
      <Site.Nav className="site-navigation" collapse={false}>
        <Dimmer active={isLoading}>
          <Nav className="site-navigation__inner">
            {this.iterateNavItems(isAuthenticated)}
          </Nav>
        </Dimmer>
      </Site.Nav>
    );
  }
}

function mapStateToProps(state) {
  return {
    isLogged: state.auth
  };
}

export default connect(mapStateToProps)(withAuth(NavigationItems));
